"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSfavState = exports.defaultSfavItemsCriteria = void 0;
var SfavState_1 = require("@/pages/search/states/SfavState");
var SavedResultItem_init_1 = require("@/pages/search/states/SavedResultItem.init");
var UserSearchSet_init_1 = require("@/pages/common/states/UserSearchSet.init");
var ResultPageState_init_1 = require("@/pages/search/states/ResultPageState.init");
exports.defaultSfavItemsCriteria = [
    {
        title: 'Related to Central',
        caption: 'For Rent',
        img: {
            path: 'https://www.okay.com/commoncontent/images/home-bg1.jpg',
            title: 'Map of Related to Central',
        },
        id: 104,
        saveId: 111,
        available: true,
    },
    {
        title: 'Nearby Aberdeen',
        caption: 'For Sale',
        img: {
            path: 'https://images.okay.com/Property/HQ/319216_636664931103107764.JPG',
            title: 'Map of Nearby Aberdeen',
        },
        id: 105,
        saveId: 112,
        available: true,
    },
    {
        title: 'Nearby Sheung Wan 20K-50K',
        caption: 'For Rent',
        img: {
            path: 'https://www.okay.com/commoncontent/images/home-bg1.jpg',
            title: 'Map of Nearby Sheung Wan',
        },
        id: 106,
        saveId: 113,
        available: true,
    },
];
exports.defaultSfavState = {
    nameMore: 'Show All',
    nameBack: 'Close',
    nameEmptyFav: 'Nothing here yet! You can click heart icon to save a property here',
    nameEmptyCriteria: 'Nothing here yet! You can click start icon to save a search',
    nameEmptyHistory: 'You can revisit your viewd properties here',
    nameUnavailable: 'Unavailable',
    nameViewLocal: 'View Local',
    nameViewInt: 'View International',
    nameForBuy: 'For Buy',
    nameForSale: 'For Sale',
    nameForRent: 'For Rent',
    nameForAll: 'For Sale / Rent',
    nameContactAgent: 'Contact',
    nameSubjectToOffer: 'Subject To Offer',
    nameFilter: 'Filter',
    opened: false,
    showFavInt: false,
    showHistoryInt: false,
    sectionFav: {
        opened: false,
        visibleSize: 4,
        key: SfavState_1.SfavSectionKey.PROPERTY,
        name: 'Favorites',
        items: [SavedResultItem_init_1.defaultSavedResultItem1, SavedResultItem_init_1.defaultSavedResultItem2],
        emptyMessage: 'Your Saved Properties list is empty.',
        more: true,
    },
    sectionFavInt: {
        opened: false,
        visibleSize: 4,
        key: SfavState_1.SfavSectionKey.PROPERTY_INT,
        name: 'Favorites',
        items: [SavedResultItem_init_1.defaultSavedResultItem2, SavedResultItem_init_1.defaultSavedResultItem1],
        emptyMessage: 'Your Saved Properties list is empty.',
        more: true,
    },
    sectionHistory: {
        opened: false,
        visibleSize: 4,
        key: SfavState_1.SfavSectionKey.HISTORY,
        name: 'Recent',
        items: [SavedResultItem_init_1.defaultSavedResultItem2, SavedResultItem_init_1.defaultSavedResultItem1],
        emptyMessage: 'Your Recently Viewed list is empty.',
        more: true,
    },
    sectionHistoryInt: {
        opened: false,
        visibleSize: 4,
        key: SfavState_1.SfavSectionKey.HISTORY_INT,
        name: 'Recent',
        items: [SavedResultItem_init_1.defaultSavedResultItem1, SavedResultItem_init_1.defaultSavedResultItem2],
        emptyMessage: 'Your Recently Viewed list is empty.',
        more: true,
    },
    sectionSavedSearch: {
        opened: false,
        visibleSize: 4,
        key: SfavState_1.SfavSectionKey.CRITERIA,
        name: 'Searches',
        items: [UserSearchSet_init_1.defaultUserSearchSetRentType],
        emptyMessage: 'Your Saved Criteria list is empty.',
        more: false,
    },
    sectionFollowingPlace: {
        opened: false,
        visibleSize: 4,
        key: SfavState_1.SfavSectionKey.PLACE,
        name: 'Following',
        items: [UserSearchSet_init_1.defaultUserSearchSetFollowDistrictType, UserSearchSet_init_1.defaultUserSearchSetFollowBuildingType],
        emptyMessage: 'Your Following Places list is empty.',
        more: false,
    },
    favActive: true,
    t: {
        inc: 'Inc.',
        forRent: '/mo',
    },
    resultT: ResultPageState_init_1.defaultResultPageState.t,
};
